<template>
    <span
        class="dropdown-header pt-0 pb-0 mt-3 ps-0"
        @click="disableClick"
    >
        {{ text }}
    </span>
</template>
<script lang="ts" setup>
import { useHelper } from '@/composeables';

const props = defineProps<{
    text: string;
}>();

/**
 * Clicking the header should do nothing
 * (If this isnt here, the dropdown will close if you click the header)
 */
const disableClick = (ev: MouseEvent) => {
    useHelper().stopPropagation(ev);
};
</script>
